import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { Info } from 'lib/styles';

import ContentFromDb from './ContentFromDb';
import TextControls from './TextControls';
import Settings from './Settings';

const Container = styled.div`
	padding: 16px 40px;
`;

const Text = props => {
	const {
		t,
		building,
		pageData,
		data: { options },
		viewSettings
	} = props;
	const buildingContent = building.i18n;
	let spaceContent = false;

	const hasSpace = 'space' in pageData.options && pageData.options.space !== null;
	const space = hasSpace ? building.spaces.find(space => space.slug === pageData.options.space) : false;

	if (space) {
		spaceContent = space.i18n;
	}

	return (
		<Container>
			{ viewSettings ?
				<Settings
					options={options}
					updateSettingsHandler={props.updateSettingsHandler}
				/> :
				<React.Fragment>
					<ContentFromDb
						buildingContent={buildingContent}
						spaceContent={spaceContent}
						editorState={props.editorState}
						changesHandler={props.changesHandler}
						updateEditorState={props.updateEditorState}
					/>
					<TextControls
						editorState={props.editorState}
						changesHandler={props.changesHandler}
						updateEditorState={props.updateEditorState}
					/>
					<Info
						icon="light-bulb"
						fill="orange"
						info={t('controls/text/info/default')}
					/>
				</React.Fragment>
			}
		</Container>
	)
}

Text.propTypes = {
	t: PropTypes.func,
	viewSettings: PropTypes.bool,
	activeSlot: PropTypes.number,
	data: PropTypes.object,
	building: PropTypes.object,
	pageData: PropTypes.object,
	editorState: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	unsavedChanges: PropTypes.object,
	changesHandler: PropTypes.func,
	updateEditorState: PropTypes.func,
	updateSettingsHandler: PropTypes.func,
}

export default translate('translations')(Text)
